import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { actionBarUpdate } from "@origin-digital/event-dispatcher";
import { isLandingPath } from "../helpers/routes";

export const useSyncActionBar = (): void => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isLanding = isLandingPath(pathname);

    actionBarUpdate({
      mobileNavButton: isLanding ? "close" : "back",
      component: isLanding ? "h1" : "h3",
    });
  }, [pathname]);
};
